import React from 'react'

import { Select } from '../../common/components/select'

import { useStyles, FILTER_MARGIN } from './filter-bar.style'

export const FilterBar = function ({ filters = [], size, alwaysShowSelectDropdown = false, onChange = () => {}, width = 1024 }) {
  const classes = useStyles()
  // Divide up the full width minus the left & right margins of each filter, max out at 250 or 200 for medium-sized filter bar
  const filterWidth = Math.min((width - (filters.length * FILTER_MARGIN * 2)) / filters.length, (size === 'medium') ? 200 : 250)

  return <div className={classes.filterRow}>
    {filters.map(({ key, label, options = [], selectedValue }) => (
      // Do not display a filter with 0 or 1 option.
      (!alwaysShowSelectDropdown && (options.filter(({ hide }) => (!hide)).length < 2))
        ? null
        : (
          <div key={key} data-qa={`filter-bar-${key}`} className={classes.filter} style={{ width: filterWidth }}>
            <Select
              size={size}
              label={label}
              options={options.filter(({ hide }) => (!hide))}
              value={options.find(({ value }) => value === selectedValue)}
              onChange={({ value }) => {
                onChange(key, value)
              }}
            />
          </div>
        )
    ))}
  </div>
}
